import React, { Component } from "react";
import Registry from "../../Utils/Registry";
import Phone from "react-phone-number-input";
import {
    Input,
    Button,
    Row,
    Col,
    Label
} from "reactstrap";
import {NotificationManager} from "react-notifications";


class AccountProfile extends Component{
    constructor(props){
        super(props);

        this.inputChanged = this.inputChanged.bind(this);
        this.sendUpdate   = this.sendUpdate.bind(this);
        this.setUser      = this.setUser.bind(this);

        this.api = Registry.registered("api");


        let user = Registry.observe(this, "user", user => {
            this.setUser(user);
        });

        this.state = {
            loading: false,
            user: user,
            errors:{
                first_name: false,
                last_name: false,
                phone_number: false,
                email: false,
                address: false,
                address2: false,
                postal_code: false,
                city: false,
                country: false
            },
            fields: {
                first_name: user ? user.first_name : "",
                last_name: user ? user.last_name : "",
                phone_number: user ? user.phone_number : "",
                email: user ? user.email : "",
                address: user ? user.address : "",
                address2: user ? user.address2 : "",
                postal_code: user ? user.postal_code : "",
                city: user ? user.city : "",
                country: user ? user.country : ""
            }
        };
    }

    inputChanged(e, input_key){
        if(this.state.fields.hasOwnProperty(input_key)){
            let nState = this.state;

            nState.fields[input_key] = (typeof e === "string" ? e : e.target.value);
            nState.errors[input_key] = false;

            this.setState(nState);
        }
    }

    setUser(user){
        this.setState({
            user: user,
            fields: {
                first_name: user.first_name,
                last_name: user.last_name,
                phone_number: user.phone_number,
                email: user.email,
                address: user.address,
                address2: user.address2,
                postal_code: user.postal_code,
                city: user.city,
                country: user.country
            }
        });
    }

    sendUpdate(){
        this.setState({loading: true});

        this.api.put("/customers/" + this.state.user.id, this.state.fields)
            .then(results => {
                Registry.register("user", results.customer);
                this.setState({loading: false}, () => {
                    NotificationManager.success(results.message);
                });
            })
            .catch(error => {
                this.setState({loading: false}, () => {
                    if(error.hasOwnProperty("details"))
                        NotificationManager.error(error.details);
                });
            });
    }


    render(){
        return (
            <Row>
                <Col xs="12" sm="12" lg="6">
                    <div className="ty-block">

                        <Row className="marg-b-10">
                            <Col md="6">
                                <Label style={this.state.errors.first_name ? {color: "red"}:{}}  className="bold">Prénom</Label>
                                <Input type="text" onChange={e => this.inputChanged(e, "first_name")} value={this.state.fields.first_name} className="wp-100" required />
                            </Col>
                            <Col  md="6">
                                <Label style={this.state.errors.last_name ? {color: "red"}:{}}  className="bold">Nom</Label>
                                <Input type="text" onChange={e => this.inputChanged(e, "last_name")} value={this.state.fields.last_name} className="wp-100" required />
                            </Col>
                        </Row>
                        <Row className="marg-t-10 marg-b-10">
                            <Col md="12">
                                <Label style={this.state.errors.phone_number ? {color: "red"}:{}}  className="bold">Téléphone</Label>
                                <div className="">
                                    <Phone country={'FR'} onChange={e => this.inputChanged(e, "phone_number")} value={this.state.fields.phone_number} className="wp-100 form-control" />
                                </div>
                            </Col>
                        </Row>
                        <Row className="marg-t-10 marg-b-10">
                            <Col md="12">
                                <Label style={this.state.errors.email ? {color: "red"}:{}} className="bold ">Email</Label>
                                <Input type="email" onChange={e => this.inputChanged(e, "email")} value={this.state.fields.email} className="wp-100" required />
                            </Col>
                        </Row>
                        <Row className="marg-t-10 marg-b-10">
                            <Col md="6">
                                <Label style={this.state.errors.address ? {color: "red"}:{}}  className="bold">Adresse</Label>
                                <Input type="text" onChange={e => this.inputChanged(e, "address")} value={this.state.fields.address} className="wp-100" required />
                            </Col>
                            <Col md="6">
                                <Label style={this.state.errors.address2 ? {color: "red"}:{}}  className="bold">Complément d'adresse</Label>
                                <Input type="text" onChange={e => this.inputChanged(e, "address2")} value={this.state.fields.address2} className="wp-100" />
                            </Col>
                        </Row>

                        <Row className="marg-t-10 marg-b-10">
                            <Col md="4">
                                <Label style={this.state.errors.postal_code ? {color: "red"}:{}} className="bold">Code postal</Label>
                                <Input type="text" onChange={e => this.inputChanged(e, "postal_code")} value={this.state.fields.postal_code} className="wp-100" required />
                            </Col>
                            <Col md="4">
                                <Label style={this.state.errors.city ? {color: "red"}:{}} className="bold">Ville</Label>
                                <Input name="city" type="text" onChange={e => this.inputChanged(e, "city")} value={this.state.fields.city} className="wp-100" required />
                            </Col>
                            <Col md="4">
                                <Label style={this.state.errors.country ? {color: "red"}:{}} className="bold">Pays</Label>
                                <Input name="country" type="text" onChange={e => this.inputChanged(e, "country")} value={this.state.fields.country} className="wp-100" required />
                            </Col>
                        </Row>
                    </div>


                    <Row className="marg-t-15">
                        <Col md="12" className="center">
                            <Button color="primary" className="text-uppercase" onClick={this.sendUpdate}>
                                {this.state.loading ? <i className="ty-icon icon icon-loading animated spin infinite f-18" /> : "Enregistrer les modifications"}
                            </Button>
                        </Col>
                    </Row>
                </Col>
            </Row>
        );
    }
}

export default AccountProfile;



// WEBPACK FOOTER //
// ./src/components/Account/Profile.js